import { IWidget } from "../../../../types/home";
import { useTheme } from "styled-components";
import { classNames, imageHelper } from "helpers/themeHelpers";
import { gtmPostLatestAds } from "GTMs/actions/homeActions";
import { viewListingAction } from "../../../../../../../libs/logging/helpers/loggingActions";
import Image from "../../../../../../../componentReusable/Image";
import {
  EnumCellType,
  EnumLoggingScreenNames,
  EnumUxTypes,
} from "../../../../../../../libs/logging/types/loggingTypes";
import { FC, Fragment } from "react";
import { linkToListingView } from "../../../../helper/links";


interface IProps {
  widget: IWidget;
}

const HomeWidgetImage: FC<IProps> = ({ widget }) => {
  const { isDesktop, isMobile, locale } = useTheme();

  const loggingObj = (item) => {
    return {
      postId: item?.id,
      city_name: item.city_reporting_name,
      neighborhood: item.neighborhood_reporting_name,
      subcategory: item.subcategory_reporting_name,
      services: item?.services || [],
      category: item.category_reporting_name,
    };
  };
  return (
    <div
      {...classNames(
        "flex flexWrap mt-16",
        isDesktop && "gap-25 mt-16",
        isMobile && "gap-10 flexWrap"
      )}
    >
      {widget?.items?.map((item, index) => {
        return (
          <a
            title={item.title}
            key={index}
            href={linkToListingView(widget, item)}
            onClick={() => {
              gtmPostLatestAds(
                widget?.gtm_config?.post?.eventAction,
                widget?.gtm_config?.post?.eventLabel,
                {
                  Category: item?.category_reporting_name,
                  SubCategory: item?.subcategory_reporting_name,
                }
              );
              viewListingAction({
                listingData: loggingObj(item) as any,
                currentScreen: EnumLoggingScreenNames.HOME,
                widgetName: widget?.gtm_config?.post?.widgetName,
                ux_type: EnumUxTypes.NA,
                cellType: EnumCellType.NA,
                referenceId: item?.member_id,
              });
            }}
            target={isDesktop ? "_blank" : "_self"}
            {...classNames(
              "homeListingItem blackColor",
              isMobile && index < 6 && "mb-8"
            )}
          >
              <Image
                src={imageHelper(item.image, isDesktop ? "300x0" : "0x240")}
                loading="lazy"
                width={isDesktop ? "220" : "110"}
                height={isDesktop ? "200" : "110"}
                {...classNames(
                    "homeListingImage radius-8 vTop grayBg",
                    isMobile && "width-100"
                )}
                alt={item.title}
              />
              {item?.price?.length > 0 && (
                <div
                  {...classNames(
                    "priceLabel relative whiteColor radius-8 center flex gap-5 mb-16 ms-auto width-fit",
                    isDesktop && "font-20",
                    isMobile && "font-12"
                  )}
                >
                  <div className="trim ltr">{item.price}</div>
                  {item.currency}
                </div>
              )}
            {item?.highlights?.length > 0 && (
              <p {...classNames("mt-8", isMobile && "font-12")}>
                {item?.highlights.replaceAll("\u200F","")}
              </p>
            )}
          </a>
        );
      })}
    </div>
  );
};
export default HomeWidgetImage;
